import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { useTheme } from '../theme/ThemeProvider';

export type DataPanelGroupProps = {
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
  testID?: string;
};

export function DataPanelGroup({ children, style, testID }: DataPanelGroupProps) {
  const theme = useTheme();

  return (
    <View
      testID={testID}
      style={[
        styles.group,
        { backgroundColor: theme.colors.surface, borderRadius: theme.radius.md },
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  group: { flexDirection: 'column', rowGap: 1, overflow: 'hidden' },
});
